import { render, staticRenderFns } from "./DeleteRoleDialog.vue?vue&type=template&id=2fa2e0e5"
import script from "./DeleteRoleDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports